import { Component } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { IonicModule, Platform } from '@ionic/angular';
import { CLIENT_APP_DOWNLOAD_LINK } from 'src/app/pages/client-app-migration/constants/client-app-download-link.constant';
import { EOLService } from 'src/app/pages/eol/eol.service';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import { HeadingComponent } from 'src/app/shared/components/heading/heading.component';

@Component({
  selector: 'app-eol',
  templateUrl: './eol.page.html',
  styleUrls: ['./eol.page.scss'],
  standalone: true,
  imports: [IonicModule, HeadingComponent, ButtonComponent],
})
export class EOLComponent {
  private isIOS = this.platform.is('ios');

  constructor(
    private platform: Platform,
    private inAppBrowser: InAppBrowser,
    private eolService: EOLService,
    private splashScreen: SplashScreen,
  ) {
    this.splashScreen.hide();
  }

  private openExternalLink(url: string, target = '_system', options = 'location=yes') {
    return this.inAppBrowser.create(url, target, options);
  }

  openAppStoreClient() {
    this.eolService.track('EOL Download Button Clicked');
    if (this.isIOS) {
      this.openExternalLink(CLIENT_APP_DOWNLOAD_LINK.ios);
    } else {
      this.openExternalLink(CLIENT_APP_DOWNLOAD_LINK.android);
    }
  }
}
